export const LanguageTypes = {
  SET_LANGUAGE: "language/SET_LANGUAGE",
};

export const setLanguage = (payload) => ({
  type: LanguageTypes.SET_LANGUAGE,
  payload,
});
